module.exports = __webpack_public_path__ + "static/media/cents3.b5c82a4f.webp";